import { Box, Grid, Card, CardContent, Paper } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { FC, useState } from 'react';
import { ManyImagesUpload } from '../../../../components';
import { createPhoto } from '../../../../fetch';
import { IPlatMap } from '../../../../models';
import { PhotoOwnerType } from '../../../../models/photo-owner-types';
import { ImageModal } from '../../../../components/file/image-upload';
import { ALLOWED_IMAGE_EXTENSIONS } from '../../../../helpers';

interface ISalesAndContractsImagesProps {
  neighborhoodId: string;
  images?: string[] | IPlatMap[];
  photoOwnerType: PhotoOwnerType;
  imageTitle: string;
  refetchPhotos: () => void;
}

export const SalesAndContractsImages: FC<ISalesAndContractsImagesProps> = ({
  neighborhoodId,
  images,
  photoOwnerType,
  imageTitle,
  refetchPhotos
}) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [source, setSource] = useState<string>('');
  const [isShowingImage, showImage] = useState<boolean>(false);
  const [isUploading, setUploading] = useState(false);
  return (
    <>
      <Box className={classes.photosContainer}>
        <Box paddingRight="24px">
          <ManyImagesUpload
            fileType={ALLOWED_IMAGE_EXTENSIONS.join(', ')}
            imageTitle={imageTitle}
            isRequired={false}
            isDisabled={isUploading}
            isLoading={isUploading}
            imageKey={photoOwnerType}
            handleFileChange={async (images: any[], files: File[]) => {
              try {
                setUploading(true);
                const formData = new FormData();
                files.forEach(file => {
                  formData.append('PhotoFile', file);
                });

                while (files.length) {
                  const formData = new FormData();
                  const firstItem = files[0];

                  formData.append('PhotoFile', firstItem);
                  await createPhoto(neighborhoodId, photoOwnerType, formData);
                  files.shift();
                }

                refetchPhotos();
              } catch (error) {
                enqueueSnackbar(error?.Detail ?? 'Error uploading images, please try again.', {
                  variant: 'error'
                });
              } finally {
                setUploading(false);
              }
            }}
            images={[]}
          />
        </Box>
      </Box>
      <Grid container spacing={1}>
        {images.map((image, index) => {
          return (
            <>
              <Grid key={`${index}-image-${photoOwnerType}`} item xs={12} md={4} xl={3}>
                <Card className={classes.card} elevation={0} variant="outlined">
                  <CardContent>
                    <Paper elevation={0} square>
                      <div>
                        <Grid container spacing={1}>
                          <Grid
                            item
                            xs={12}
                            onClick={() => {
                              setSource(image && image.imageUrl ? image.imageUrl : image);
                              showImage(true);
                            }}
                          >
                            <img
                              className={classes.pics}
                              key={`${index}`}
                              alt={`${photoOwnerType}-${index}`}
                              src={image && image.imageUrl ? image.imageUrl : image}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    </Paper>
                  </CardContent>
                </Card>
              </Grid>
              <ImageModal
                isOpen={isShowingImage}
                onClose={() => showImage(false)}
                source={source}
              />
            </>
          );
        })}
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  photosContainer: {
    display: 'flex',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    },
    '@media print': {
      display: 'block'
    }
  },
  pics: {
    display: 'block',
    margin: '0 auto',
    maxHeight: 125,
    maxWidth: '100%'
  },
  card: {
    cursor: 'pointer',
    height: 150,
    textAlign: 'center'
  }
}));
